var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4625 5.87625C4.89375 6.19125 5.42625 6.375 6 6.375C7.40325 6.375 8.625 5.16038 8.625 3.75C8.625 2.3025 7.4475 1.125 6 1.125C4.5525 1.125 3.375 2.3025 3.375 3.75C3.375 4.62375 3.8025 5.4 4.4625 5.87625Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31 6.2063C7.70625 6.7763 6.8925 7.12505 6 7.12505C5.1075 7.12505 4.29375 6.7763 3.69 6.2063C2.16375 7.0313 1.125 8.64755 1.125 10.5C1.125 10.7063 1.29375 10.875 1.5 10.875H10.5C10.7063 10.875 10.875 10.7063 10.875 10.5C10.875 8.64755 9.83625 7.0313 8.31 6.2063Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.b680f4c0.svg";
export { ForwardRef as ReactComponent };